import { useState, useEffect } from "react";
import { RiskProfileDetailModal } from "@/components/modals/RiskProfileDetailModal";
import { useListCustomerProfiles } from "@/lib/api/risk/profiles";
import type { RiskCropProfile, RiskCropProfileHistory } from "@/lib/api/risk/profiles";

interface RiskProfileHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  customerId: string;
  commodityType: string;
  cropYear: number;
}

export function RiskProfileHistoryModal({
  isOpen,
  onClose,
  customerId,
  commodityType,
  cropYear,
}: RiskProfileHistoryModalProps) {
  const [profile, setProfile] = useState<RiskCropProfile | null>(null);
  const [histories, setHistories] = useState<RiskCropProfileHistory[] | null>(null);

  // Fetch all profiles for this customer
  const listProfilesResult = useListCustomerProfiles({
    customer_id: customerId,
    filters: {
      is_enabled: true,
      crop_year: [cropYear],
    },
  });

  const customerData = listProfilesResult?.data?.data || {};

  useEffect(() => {
    if (customerData?.profiles && customerData?.histories) {
      // Find the specific profile matching the commodity type and crop year
      const matchingProfile = customerData.profiles.find((p: RiskCropProfile) =>
        p.commodity_type === commodityType && 
        p.crop_year === cropYear
      );

      if (matchingProfile) {
        setProfile(matchingProfile);
        
        // Filter histories for this specific profile
        const profileHistories = customerData.histories.filter((h: RiskCropProfileHistory) =>
          h.profile_id === matchingProfile.id
        );
        setHistories(profileHistories);
      } else {
        // No matching profile found
        setProfile(null);
        setHistories(null);
      }
    }
  }, [customerData, commodityType, cropYear]);

  return (
    <RiskProfileDetailModal
      isOpen={isOpen}
      onClose={onClose}
      profile={profile}
      histories={histories}
    />
  );
}
